// @flow
import React from 'react';
import SingleDropdown from './single_dropdown';
import { useSingleDropdown } from './index';
import type { Item, ItemFetcher } from './item';

type Props = {
  items: Array<Item> | ItemFetcher,
  label: string,
  selectedItem?: Item | null,
  onSelectedItemChange?: (Item) => void,
  error?: boolean,
  disabled?: boolean,
};

const SimpleSingleDropdown = ({
  items,
  label,
  selectedItem,
  onSelectedItemChange,
  error,
  disabled,
}: Props) => {
  const wrappedSelectedItemChanged = (event) =>
    onSelectedItemChange && onSelectedItemChange(event.selectedItem);

  const dropdownProps = useSingleDropdown({
    items,
    selectedItem,
    onSelectedItemChange: wrappedSelectedItemChanged,
  });

  return (
    <SingleDropdown>
      <SingleDropdown.Field
        dropdownProps={dropdownProps}
        label={label}
        error={error}
        disabled={disabled}
      />
      <SingleDropdown.Flyout dropdownProps={dropdownProps} />
    </SingleDropdown>
  );
};

export default SimpleSingleDropdown;
